import { Control, Controller, Path } from 'react-hook-form';
import { Option } from 'types/general.types';
import { ChakraAutocompleteProps } from 'app/components/Core/ChakraAutocomplete/types';
import { ChakraAutocomplete } from '../ChakraAutocomplete/ChakraAutocomplete';

export interface ChakraAutocompleteFieldProps<Form extends {}>
  extends Omit<ChakraAutocompleteProps<Option>, 'getOptionLabel'> {
  control: Control<Form>;
  name: Path<Form>;
  getOptionLabel?: ChakraAutocompleteProps<Option>['getOptionLabel'];
}

export const ChakraAutocompleteField = <Form extends {}>({
  control,
  name,
  onBlur: onBlurProp,
  onChange: onChangeProp,
  ...rest
}: ChakraAutocompleteFieldProps<Form>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { value, ref, onBlur, onChange, ...fieldProps },
        fieldState: { error },
      }) => (
        <ChakraAutocomplete<Option>
          value={value as Option}
          isInvalid={Boolean(error?.message)}
          errorMessage={error?.message}
          mainRef={ref}
          getOptionLabel={(option) => option?.title || ''}
          onBlur={(e) => {
            onBlur();
            if (onBlurProp) {
              onBlurProp(e);
            }
          }}
          onChange={(e) => {
            onChange(e);
            if (onChangeProp) {
              onChangeProp(e);
            }
          }}
          {...rest}
          {...fieldProps}
        />
      )}
    />
  );
};
